
<script>
    import PreviewComponent from "./PreviewComponent";    
    import PaymentBillingInfoComponent from '../../components/pagesbuilder/dynamic-components/PaymentBillingInfoComponent';
    

    export default {
        name: "PreviewPaymentBillingInfoComponent",
        mixins: [PreviewComponent, PaymentBillingInfoComponent],                        
        methods:{
                        
        }
    }
</script>
